<div class="de-toolbar">
  <q9-toolbar>
    <div q9-right-content [style]="{'grid-template-columns': gridTemplateColumns}">
      <ng-container *ngFor="let btn of activityTypes">
        <div [matTooltip]="btn.tooltip | translate" matTooltipPosition="above">
          <button
            *ngIf="btn.img"
            #activityDragElement
            mat-icon-button
            color="primary"
            class="toolbar-activity-image">
            <img [src]="btn.img" alt="activity" />
          </button>
          <q9-icon-button
            *ngIf="btn.icon"
            #activityDragElement
            class="sb-toolbar-actions"
            [icon]="btn.icon"></q9-icon-button>
        </div>
      </ng-container>
    </div>
  </q9-toolbar>
</div>
